@if (!loading) {
  <div class="dialog-top position-relative" >
    <img class="w-100" src="{{data.image}}" alt="{{data.image_alt}}"/>
    <!--     <div *ngIf="data.highlight" class=" circle highlight text-center d-flex align-items-center justify-content-center">-->
    <!--     <span [innerHTML]="data.highlight"></span>-->
  </div>
}

@if (!loading) {
  <div class="mt-xxl mb-0 dialog-popup" [attr.data-popup-title]="data.title" [attr.data-popup-type]="data.dialog_popup_type">
    <h2 class="pb-s survey-title" [innerHTML]="data.title"></h2>
    @for (part of parsedBody; track part) {
      <div>
        @if (part.type == 'string') {
          <div [innerHTML]="part.data"></div>
        }
        @if (part.type=='form') {
          <app-forms [form]="part.data" (success)="onSuccess($event)"
          [rating]="true"></app-forms>
        }
        @if (part.type =='email') {
          <div class="email w-100">
            <div class="d-flex justify-content-start align-items-center mb-s">
              <span class="oval">{{ part.email }}</span>
              <button class="btn btn-primary mt-0 ml-m" (click)="onSubscribe(part.email, part.data)"><mat-icon>check</mat-icon> OK
            </button>
          </div>
          <ng-container class="mt-m">
            @if (success) {
              <notification type="success" html="{{message}}"></notification>
            }
          </ng-container>
        </div>
      }
    </div>
  }
</div>
}
@if (!sent) {
  <div mat-dialog-actions class="my-0 ">
    <div class="d-flex justify-content-start align-items-end w-100">
      <button class="btn btn-primary" (click)="redirect()">Aboeinstellung Aktualisieren</button>
      <button class="btn btn-secondary" [mat-dialog-close]="true" (click)="subscribe(data.image_alt)">Später
        Erinnern
      </button>
    </div>
  </div>
}
